  <!--  积分到期 -->
  <template>
    <div class="box">
        <div class="tab-box">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedRegion.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup"
                    class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{checkedStore.name}}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png"
                        alt="">
                </div>
            </div>
            <div class="search">
                <form action="/">
                    <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear"
                        placeholder="搜索姓名/手机"
                        left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
            </div>
        </div>
        <div class="flex flex-start">
            <div class="select-box flex flex-y-center flex-start">
                <div class="select-item mr-50 flex-between flex-y-center" @click="selectEmployeePopup">
                    <div class="select-tit">{{ checkedEmployee && checkedEmployee.name }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
            </div>
            <div class="select-box flex flex-y-center flex-start">
                <div class="select-item flex-between flex-y-center" @click="selectTypePopup">
                    <div class="select-tit">{{ checkedType && checkedType.name }}</div>
                    <van-icon name="play" class="select-arrow" />
                </div>
            </div>
        </div>
        <div class="table">
            <div class="table-tab  flex flex-x-center flex-start">
                <div :class="`tab-item ${tabIndex == 1?'active':''}`" @click="clickTab(1)">
                    当前剩余
                </div>
                <div :class="`tab-item item-text ${tabIndex == 2?'active':''}`" @click="clickTab(2)">
                    即将过期
                </div>
            </div>
            <div class="box-line"></div>
            <div class="list-box">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
                    <van-list v-model="loading" :finished="finished" :loading="loading" finished-text="没有更多了" @load="getCustList"
                        :offset="20" :immediate-check="false">
                        <div class="customer-list flex-col" v-for="(item, index) in customerList" :key="index"
                            @click="toDetail(item.custId,item.phone)">
                            <div class="top-box flex-row">
                                <img class="customerHeadPortrait" referrerpolicy="no-referrer"
                                    :src="item.avatar?item.avatar:'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                                <div class="customer-info flex-1 flex-y-center flex-start">
                                    <div class="customer-name">{{item.username}}</div>
                                    <img class="card-icon" referrerpolicy="no-referrer" v-if="item.cardLevelName"
                                        :src="item.cardLevelName" alt="" />
                                    <div class="customer-name flex-1 flex-y-center"> <img class="arrow_right"
                                            referrerpolicy="no-referrer" alt=""
                                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                                    </div>
                                    <img class="icon-item chat-icon" referrerpolicy="no-referrer" @click.stop="toOpenWechat(item)"
                                        alt="" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/chat-icon.png" />
                                    <img class="icon-item" referrerpolicy="no-referrer" @click.stop="toContact(item.phone)" alt=""
                                        src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/phone-icon.png" />
                                </div>

                            </div>
                            <div class="customer-remark flex-between flex-col">
                                <div class="flex-between flex-y-center mb-20">
                                    <span class="sale-name">顾问：</span>
                                    <span class="sale-box flex-1">{{item.empName}}</span>
                                </div>
                                <div class="flex-between flex-y-center mt10 mb-20">
                                    <span class="sale-name">上次到店：</span>
                                    <span class="sale-box flex-1">{{item.transDate}}</span>
                                </div>
                                <div class="flex-between flex-y-center mb-20">
                                    <span class="sale-name">剩余积分：</span>
                                    <span class="sale-box flex-1">{{item.balanceAmount}}</span>
                                </div>
                                <div class="flex-between flex-y-center mt10 mb-20">
                                    <span class="sale-name">30天内即将到期积分：</span>
                                    <span class="sale-box flex-1">{{item.expireThirtyDayAmount}}</span>
                                    <div class="sale-more flex-between flex-y-center" @click="toRemainDetail(item)">
                                        <span>查看更多</span><img class="sale-arrow-right" referrerpolicy="no-referrer" alt=""
                                            src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/arrow_right.png" />
                                    </div>
                                </div>

                            </div>

                        </div>
                    </van-list>
                </van-pull-refresh>
                <van-popup v-model="showEmployeePopup" round position="bottom" closeable class="popup" get-container="#app">
                    <picker title="全部员工" v-model="checkedEmployee" :list="employeeList" @change="onEmployeeChange">
                    </picker>
                </van-popup>
                <van-popup v-model="showTypePopup" round position="bottom" closeable class="popup" get-container="#app">
                    <picker title="选择类型" v-model="checkedType" :list="typeList" @change="onTypeChange"></picker>
                </van-popup>
                <!-- 区经区总 切换区域 -->
                <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
                    <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
                </van-popup>
                <!-- 区经区总 切换门店 -->
                <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
                    <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
                </van-popup>
            </div>
        </div>
    </div>
</template>

  <script>
import request from "@/utils/request";
import { getCookie } from '@/utils'
import { Toast } from 'vant'
import { timestampToYestoday } from '@/utils/validate';
import { openEnterpriseChat } from '@/utils/wxCodeAuth'
import Picker from '@/components/Picker';
import { mapState } from 'vuex'
import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'

export default {
    name: "newIntegralRemind",
    inject: ['reload'],
    components: {
        Picker
    },
    data() {
        return {
            tabIndex: 1, // tab栏下标
            searchStr: "",
            loading: false,
            finished: false,
            refreshing: false,
            page: 1,
            total: 0,
            customerList: [
            ],
            updateTime: timestampToYestoday(),   //更新时间
            postId: 0, // 岗位
            showRegionPopup: false,
            showRegionStorePopup: false,
            regionStoreList: [],//区域门店列表
            regionList: [],//区域列表
            checkedRegion: { id: -1, name: '' },//所选区域
            checkedStore: {  //所选门店
                name: '',
                id: -1,
            },
            checkedEmployee: null,//所选员工
            checkedType: { id: '1', name: '剩余积分降序' },//所选类型
            showEmployeePopup: false,// 选择员工弹窗
            showTypePopup: false,// 选择类型弹窗
            employeeList: [], // 员工
            typeList: [{
                name: '剩余积分降序',
                id: "1"
            },
            {
                name: '即将到期积分降序',
                id: "2"
            },]
        };
    },
    computed: {
        ...mapState({
            regionPostId: (state) => {
                return state.user.permissions.regionPostId
            },// 区经区总id
        }),
    },
    mounted() {
        this.postId = getCookie('postId') || localStorage.getItem('postId');
        // 获取当前登陆人所记录的区域门店信息
        getUserLogin().then((res) => {
            if (this.regionPostId.includes(this.postId)) {
                this.checkedRegion.name = res.data.region?.storeName // 当前区域
                this.checkedRegion.id = res.data.region?.id
                if (res.data.store) {
                    this.checkedStore.name = res.data.store.storeName //当前门店
                    this.checkedStore.id = res.data.store.id
                    // 门店列表
                    let params = {
                        id: this.checkedRegion.id
                    }
                    getRegionStoreList(params).then((res) => {
                        this.regionStoreList = res.data
                    })
                }
                // 区域列表
                getRegionStoreList().then((res) => {
                    this.regionList = res.data
                })
                // 如果当前没有选择门店记录，则进入大区页面
                if (this.checkedStore.id == 0 || this.checkedStore.id == -1) {
                    this.$router.replace({
                        name: "integralRemindRegionPage"
                    });
                }
            }
            this.getEmpList()
            this.getCustList()
        })
    },
    methods: {
        getCustList() {
            let params = {
                limit: 10,
                page: this.page,
                searchStr: this.searchStr,
                selectType: this.tabIndex,
                employeeId: this.checkedEmployee && this.checkedEmployee.id,
                type: this.checkedEmployee && this.checkedType.id,
            }
            if (this.regionPostId.includes(this.postId)) {
                params.id = this.checkedRegion.id
                params.storeId = this.checkedStore.id
            }
            request({
                url: `/index/accountBalance/balancePage`,
                method: "get",
                params: params
            })
                .then((res) => {
                    this.customerList = this.page == 1 ? res.data.list : this.customerList.concat(res.data.list);
                    this.page += 1;
                    this.total = res.data.total;
                }).catch((error) => {
                    this.finished = true
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loading = false;
                    if (this.customerList.length >= this.total) {
                        this.finished = true;
                    }
                });
        },
        // 获取员工列表
        getEmpList() {
            const sendData = {
                storeId: this.checkedStore.id,
            }
            return request({
                url: '/workEmployee/getEmployeeList',
                method: "get",
                params: this.dimension == 1 ? '' : sendData
            })
                .then((res) => {
                    this.employeeList = res.data
                    this.checkedEmployee = this.employeeList[0] //默认全部

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        //跳转顾客详情页
        toDetail(custId, phone) {
            this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
        },

        // tab切换
        clickTab(tabIndex) {
            this.tabIndex = tabIndex
            this.onRefresh();
        },

        // 查询
        onSearch(e) {
            this.searchStr = e
            this.onRefresh();
        },
        //清除搜索
        selClear() {
            this.searchStr = "";
            this.onRefresh();
        },
        onRefresh() {
            this.page = 1
            // 清空列表数据
            this.finished = false;
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true;
            this.customerList = [];
            this.refreshing = false;
            this.getCustList()
        },
        // 去打电话
        toContact(phone) {
            window.location.href = `tel:${phone}`;
        },
        //打开会话
        toOpenWechat(item) {
            if (item.wxExternalUserid && item.isWxContact == 1)   //是好友有userid，打开会话
                openEnterpriseChat('', item.wxExternalUserid, '', '')
            else
                //跳转至绑定客户界面
                this.$router.push({ name: "toBindingCustomer", query: { custName: item.username, mobile: item.phone, accountNo: item.accountNo, pageName: "", customerListSearchStr: this.searchStr, customerListQueryType: this.queryType } });
        },
        // 去券详情查看更多
        toRemainDetail(item) {
            this.$router.push({ name: "remainDetail", query: { custId: item.custId, tabName: 'consume', currentConsumeType: 5, balanceAmount: item.balanceAmount, accountNo: item.accountNo } });
        },
        // 弹窗
        selectEmployeePopup() {
            this.showEmployeePopup = true
        },
        selectTypePopup() {
            this.showTypePopup = true
        },
        // 筛选相关
        onEmployeeChange(data) {
            this.checkedEmployee = data
            this.showEmployeePopup = false
            this.onRefresh()
        },
        onTypeChange(data) {
            this.checkedType = data;
            this.showTypePopup = false;
            this.onRefresh();
        },
        // 筛选区域门店相关
        openRegionPopup() {
            this.showRegionPopup = true
        },
        onRegionChange(data) {
            this.checkedRegion = data
            this.showRegionPopup = false
            this.$nextTick(() => {
                // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                this.checkedStore.id = 0
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then((res) => {
                    this.reload()
                })
            })
        },
        openRegionStorePopup() {
            this.showRegionStorePopup = true
        },
        onRegionStoreChange(data) {
            this.checkedStore = data
            this.showRegionStorePopup = false
            let params = {
                id: this.checkedRegion.id,
                storeId: this.checkedStore.id
            }
            saveRegionStore(params).then(() => {
                if (data.id == 0 || data.id == -1) {
                    this.$router.replace({
                        name: "integralRemindRegionPage"
                    });
                } else {
                    this.reload();
                }
            })

        },
    },
};
</script>

<style scoped lang="less">
.box {
    height: 100%;
}
.tab-box {
    width: 750px;
    background: #f5f6f7;
}
.change-box {
    height: 80px;
    width: 200px;
}
.table-tab {
    height: 100%;
    display: flex;
}
.tab-item {
    height: 42px;
    font-size: 30px;
    font-weight: 400;
    color: #a0acb5;
    text-align: center;
    position: relative;
}
.item-text {
    margin-left: 179px;
}
.tab-item.active {
    color: #35434c;
    font-weight: bold;
}
.tab-item.active::after {
    position: absolute;
    bottom: -20px;
    content: "";
    width: 110px;
    height: 4px;
    background: #37dbe0;
    left: 50%;
    transform: translateX(-50%);
}
.box-line {
    width: 690px;
    height: 1px;
    background: #d7d7d7;
    margin: 20px 0 0 30px;
    opacity: 0.5;
}
.update-time {
    height: 37px;
    font-size: 26px;
    color: #a0acb5;
    line-height: 37px;
    margin: 30px 30px 0 30px;
}
.list-box {
    width: 100%;
    height: calc(100vh - 245px);
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
    padding: 30px 30px 30px 30px;
}
.customer-list {
    width: 690px;
    background: #fafafe;
    border-radius: 20px;
    padding: 30px 0 10px 30px;
    position: relative;
    margin-bottom: 20px;
    .used-icon {
        width: 196px;
        height: 196px;
        position: absolute;
        right: 32px;
        bottom: 38px;
    }
    .top-box {
        padding: 0 20px 0 20px;
    }
    .customer-name {
        min-width: 60px;
        font-size: 30px;
        color: #35434c;
        font-weight: 700;
    }
    .churn-time {
        height: 37px;
        font-size: 26px;
        color: #66757f;
        line-height: 37px;
        margin-top: 14px;
    }
    .emp-name {
        margin-top: 4px;
    }
    .nursing-edit-box {
        margin: 37px 0 0 163px;
    }
    .card-icon {
        width: 90px;
        height: 34px;
        margin-left: 10px;
    }
    .arrow_right {
        width: 15px;
        height: 26px;
        margin-left: 20px;
    }
    .icon-item {
        width: 46px;
        height: 46px;
    }
    .chat-icon {
        margin-right: 40px;
    }
    .cake-icon {
        width: 28px;
        height: 26px;
        margin-right: 11px;
    }
    .card-image {
        height: 34px;
        width: 90px;
        margin: 24px 0 0 10px;
    }
    .customerHeadPortrait {
        width: 90px;
        height: 90px;
        border-radius: 45px;
        margin-right: 20px;
    }
    .customer-remark {
        padding: 30px 20px 0 20px;
        margin-top: 20px;
        border-top: 1px solid #d7d7d7;
    }
    .sale-name {
        min-width: 100px;
        height: 40px;
        font-size: 28px;
        color: #66757f;
        line-height: 40px;
    }
    .sale-box {
        font-size: 28px;
        color: #66757f;
        line-height: 40px;
    }
    .sale-more {
        height: 26px;
        font-weight: 400;
        font-size: 26px;
        color: #a0acb5;
        letter-spacing: 1px;
        .sale-arrow-right {
            width: 15px;
            height: 26px;
            margin-left: 10px;
        }
    }
    .sale-number {
        height: 45px;
        font-size: 28px;
        color: #35434c;
        line-height: 45px;
        margin-top: 28px;
        min-width: 40px;
        font-weight: 700;
    }
}

.van-pull-refresh {
    min-height: 100%;
}
.store-box {
    padding: 30px 30px 0 30px;
    background-color: #fff;
    .store-arrow {
        width: 16px;
        height: 26px;
        margin-left: 8px;
        margin-top: 3px;
    }
    .region-name-box {
        min-width: 239px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        margin-right: 10px;
        padding: 10px 15px 11px 16px;
    }
    .store-name-box {
        min-width: 187px;
        height: 58px;
        background: #f5f5f5;
        border-radius: 35px;
        padding: 10px 15px 11px 16px;
    }
    .name-txt {
        color: #66757f;
        font-size: 26px;
    }
}
.select-box {
    margin-left: 30px;
    margin-bottom: 40px;
    .select-tit {
        font-size: 28px;
        color: #35434c;
    }
    .select-arrow {
        transform: rotate(90deg);
        font-size: 24px;
        margin-left: 10px;
    }
}
:deep(.search .van-search) {
    background-color: #fff !important;
    padding: 34px 30px 30px 30px !important;
}
:deep(.search .van-icon) {
    font-size: 28px;
}
:deep(.search .van-search__content) {
    padding-left: 0 !important;
}
:deep(.van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 8px 20px 0 20px !important;
    margin-right: 0 !important;
}

:deep(.van-tabs__nav) {
    background-color: #f5f6f7 !important;
}

:deep(.van-list__finished-text) {
    height: 280px !important;
}
:deep(.van-tab--active) {
    font-weight: 400 !important;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}

:deep(.van-dropdown-menu__title::after) {
    border-color: transparent transparent #35434c #35434c !important;
    border-top-width: 7px !important;
    border-right-width: 7px !important;
    border-bottom-width: 7px !important;
    border-left-width: 7px !important;
    border-top-style: solid !important;
    border-right-style: solid !important;
    border-bottom-style: solid !important;
    border-left-style: solid !important;
}
</style>


